import { FC } from 'react';
import TripCartCaptainDropdown from 'src/trip-cart-deprecated/components/TripCartCaptainDropdown';
import TripCartMultiDayDropdown from 'src/trip-cart-deprecated/components/TripCartMultiDayDropdown';
import styles from './TripCartCaptainAndMultiDay.module.scss';

const TripCartCaptainAndMultiday: FC = () => (
  <div className={styles.root}>
    <TripCartMultiDayDropdown />
    <TripCartCaptainDropdown />
  </div>
);

export default TripCartCaptainAndMultiday;
